/* eslint-disable */
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var isHidden = function isHidden(el) {
  return el.offsetParent === null;
};

exports.default = isHidden;